import React, { Component } from 'react';
import Genres from './Genres';
import moment from 'moment';

class MakeSets extends Component{
  constructor(props){
    super(props);
    this.state={
      genres:[]
    }
  }
  makeSets(){
    let gigtitle = this.refs.gigtitle.value;
    let maxminutes = this.refs.maxminutes.value;
    let maxhrs;
    if(maxminutes>60){
      maxhrs = 0;
      while(maxminutes>60){
        maxminutes = maxminutes-60;
        maxhrs++;
      }
      maxhrs = moment.duration({hours:maxhrs})._milliseconds;
      console.log('maxhours value entered by user: ',maxhrs);
    }
    //format in moment.js

    console.log('maxminutes value entered by user: ',maxminutes);
    maxminutes = moment.duration({minutes:maxminutes})._milliseconds;
    let max;
    if(maxhrs){
      max = maxminutes + maxhrs;
    }else{
      max = maxminutes;
    }
    let genresdesired = this.state.genres;
    let setsdesired = this.refs.setsdesired.value;
    this.props.makeSets(gigtitle,max,genresdesired,setsdesired);
  }
  addGenre(genre){
    let current_genres = this.state.genres;
        //loop through array and test if genre is already there
        //if yes, remove it:
       if(this.testValue(genre,current_genres)){
         this.removeValue(genre,current_genres);
       }else{
        //if no, push it to genres:
        current_genres.push(genre);
       //  console.log('current genres: ',current_genres);
        this.setState({
          genres:current_genres
        });
       }
    //update the current genres array in state:
    this.setState({
      genres:current_genres
    });

    this.makeSets();
  }
  testValue(x,array){
    for(let i=0; i<array.length; i++){
      if(x==array[i]){
        return true;
      }
    }
    return false;
  }
  removeValue(x,array){
    for(let i=0; i<array.length; i++){
      if(x==array[i]){
        array.splice(i,1);
      }
    }
  }
  render(){
    return(
      <div>
      <div className="form-group">
        <label for="title-input">Gig Name</label>
        <input onKeyUp={this.makeSets.bind(this)} id="title-input" ref="gigtitle" type="text" className="form-control">

        </input>
        <label for="set-input">Sets Desired</label>
        <input onKeyUp={this.makeSets.bind(this)} id="set-input" ref="setsdesired" type="number" placeholder="enter a number here" className="form-control"></input>
        <label for="maxmin-input">Max Minutes</label>
        <input onKeyUp={this.makeSets.bind(this)} id="maxmin-input" ref="maxminutes" type="number" placeholder="enter a number here" className="form-control"></input>
        {/* <label for="lyrics-input">Songs</label>
        {songs} */}
      </div>

      <Genres genres={this.state.genres} addGenre={this.addGenre.bind(this)} />

    </div>
    );
  }
}

export default MakeSets;



// WEBPACK FOOTER //
// ./src/components/MakeSets.js